import { render, staticRenderFns } from "./comp_ProductPromotionSelector.vue?vue&type=template&id=f2bfb212&"
import script from "./comp_ProductPromotionSelector.vue?vue&type=script&lang=js&"
export * from "./comp_ProductPromotionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports